import { theme } from "@chakra-ui/core";

const brandPrimaryColor = "#202945";
const brandSecondaryColor = "#e73843";
const brandTertiaryColor = "#00893E";
const brandQuaternaryColor = "#75AB3B";
const brandGreyColor = "#D8DFE1";
const brandLightGreyColor = "#EBEFF0";

// [container, breakpoint]
const sizes = {
    sm: ["100%", "576px"],
    md: ["100%", "768px"],
    lg: ["100%", "992px"],
    xl: ["1360px", "1280px"],
};

const breakpoints = Object.values(sizes).reduce((bp, size) => {
    bp.push(size[1]);
    return bp;
}, []);

breakpoints.sm = breakpoints[0];
breakpoints.md = breakpoints[1];
breakpoints.lg = breakpoints[2];
breakpoints.xl = breakpoints[3];

export const EditorTheme = {
    ...theme,
    breakpoints,
    colors: {
        ...theme.colors,
        brand: {
            black: "#000000",
            white: "#ffffff",
            grey: brandGreyColor,
            lightGrey: brandLightGreyColor,
            primary: brandPrimaryColor,
            secondary: brandSecondaryColor,
            tertiary: brandTertiaryColor,
            quaternary: brandQuaternaryColor,
        },
    },
    fonts: {
        ...theme.fonts,
        heading: "TambaSansBold, sans-serif",
        body: "TambaSansLight, sans-serif",
    },
};

export const AdminTheme = {
    breakpoints: {
        mobileS: 320,
        mobileM: 375,
        mobileL: 425,
        tablet: 768,
        laptop: 992,
        desktop: 1024,
        desktopL: 1700,
    },
};
